
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 32.191 24.637"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M8.794 2.274v6.52h-6.52v-6.52h6.52M11.065 0H0v11.068h11.065V0zM13.361 0v3.581h18.83V.003z"}}),_c('path',{staticClass:"a",attrs:{"d":"M3.579 3.579h3.91v3.91h-3.91zM13.36 5.695h12.185v3.588H13.36zM8.794 15.843v6.52h-6.52v-6.52h6.52m2.271-2.274H0v11.068h11.065V13.569zM13.361 13.569v3.578h18.83v-3.578zM13.36 19.265h12.185v3.588H13.36z"}})])
          )
        }
      }
    